import React from "react";
import Link from "gatsby-link";
import Icon from "../Icon";
import { longDate } from "../../util/helperFunctions";

const BackBannerBlock = ({ page }) => {
  let route;
  let string = page.route;
  let substring = "friday-cheers";

  if (string.includes(substring)) {
    page.section = "Friday Cheers";
    const strings = page.route.split("/");
    const parts = strings.filter(p => p != "");
    parts.length = 2;
    const buildRoute = parts.join("/");
    route = `/${buildRoute}/`;
  } else {
    route = "/our-events/";
  }

  return (
    <div className="banner--back-block flex flex-column w-100 mw-1060 center">
      <Link
        to={route}
        className="banner--back-block__link flex items-center justify-center grey1 ttu pv1 pv2-l w-100"
      >
        <Icon
          path="arrow-left"
          width="32"
          height="18"
          className="banner--back-block__icon flex items-center"
        />
        <p className="ml1 mb0 h-5">{page.section}</p>
      </Link>
      <div className="banner--back-block__info bg-gold flex flex-column items-center pt3 pt6-l">
        <div className="w-calc-64 mw-696">
          <h2 className="tl h-2--small h-2--l mb1">
            {page.eventDate && longDate(page.eventDate)}
            {page.endDate && (
              <span>
                {" "}
                -<br /> {longDate(page.endDate)}
              </span>
            )}
          </h2>
          <h1 className="banner--back-block__info--headline dark h-2 h-1--l tl">
            {page.title}
          </h1>
        </div>
      </div>
    </div>
  );
};

export default BackBannerBlock;



// WEBPACK FOOTER //
// ./src/components/Banners/BackBannerBlock.js